import React from 'react';

export default function Paginator(props) {
  const { pageCount, currentPage, onChangePage } = props;

  if (pageCount <= 1) {
    return null;
  }

  return (
    <div className="boxcast-page-controls">
      <button type='button'
        disabled={currentPage == 1}
        onClick={(e) => {
          e.preventDefault();
          onChangePage(currentPage - 1);
        }}
      >
        Previous Page
      </button>
      <span>
        Page {currentPage} of {pageCount}
      </span>
      <button type='button'
        disabled={currentPage == pageCount}
        onClick={(e) => {
          e.preventDefault();
          onChangePage(currentPage + 1);
        }}
      >
        Next Page
      </button>
    </div>
  );
}
